import { PhoneNumberInput } from '@src/design-system/phone-number-input';

import type { TDynamicFilterProps } from '../filter-popover-content/dynamic-filters/dynamic-filter-value-input';

export function DynamicPhoneNumberFilter({
  onChange,
  values,
}: TDynamicFilterProps) {
  return (
    <PhoneNumberInput
      size='sm'
      onChange={(newValue) => onChange([newValue as string])}
      value={values[0]}
    />
  );
}
